import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ExpensesPage() {
  return <InstituteCrudPage config={entityConfigs['expenses']} />;
}
